export default __webpack_public_path__ + "static/meet-our-team-e6bbe5b6b5afcdc5a346fdfafecc93ca.svg";